import { Alert } from '@mui/material';
import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { H } from '../Layout';

export default function RenderProfileErrorMessage({
    hide,
    errorMessage,
    setIsSaveDisabled
}: {
    hide: boolean;
    errorMessage: string;
    setIsSaveDisabled: Dispatch<SetStateAction<boolean>>;
}) {
    useEffect(() => {
        setIsSaveDisabled(true);
    }, [errorMessage]);

    //This is a Regex method we are using to replace the string email value from the json with an <a> tag link
    const message = errorMessage.replace(
        new RegExp(`\\b(support@showrunnr.com)\\b`, 'gi'),
        `<a style="text-decoration:none" href="mailto:support@showrunnr.com">$1</a>`
    );
    return (
        !hide && (
            <Alert severity="info" sx={{ width: '100%' }}>
                <H>
                    <div style={{ textDecoration: 'none' }} dangerouslySetInnerHTML={{ __html: message }}></div>
                </H>
            </Alert>
        )
    );
}
